/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMPasswordRecoveryBeginPayload } from '@/data/types/GTM';

export const getGTMPasswordRecoveryBeginEventData = (payload: GTMPasswordRecoveryBeginPayload) => ({
	login_origin: payload.login_origin,
});
